// extracted by mini-css-extract-plugin
export default {"info":"styles_info__Mlse0","icon":"styles_icon__rKu5X","text":"styles_text__lqelK","lockIcon":"styles_lockIcon__l3H97"};